module.exports = __webpack_public_path__ + "img/va.90e9f73a.svg";